import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import { registerSW } from 'virtual:pwa-register'
import router from './router'
import i18n from './i18n'
import App from './App.vue'
import './styles/main.css'

import { errorLog } from './utils/logger'

async function initApp() {
  const app = createApp(App)

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    tracesSampleRate: 0.1,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
    ignoreErrors: [
      // Firestore internal IndexedDB persistence cache errors — benign, not actionable
      /Object Not Found Matching Id/,
    ],
  })

  app.use(createPinia())
  app.use(router)
  app.use(i18n)
  app.mount('#app')

  // Registro manual del SW para capturar errores (Safari privado, cuota llena,
  // extensiones bloqueando...) y evitar unhandled promise rejections en Sentry.
  registerSW({
    immediate: true,
    onRegisterError(err) {
      errorLog.error('SW registration failed', err)
    },
  })
}

initApp().catch(errorLog.error)
